export function offsetDate(date) {
    date.setTime(date.getTime() + (date.getTimezoneOffset() + 480) * 60 * 1000);
    return date;
}

export function convertSecToHMS(time) {
    if (time && time > 0) {
        let sec = Math.floor(time / 1000);
        let min = Math.floor(sec / 60);
        let hour = Math.floor(min / 60);
        let seconds = sec % 60;
        if (seconds === 0) {
            seconds = '00';
        } else if (seconds < 10) {
            seconds = '0' + seconds;
        }
        let minutes = min % 60;
        if (minutes === 0) {
            minutes = '00:';
        } else if (minutes < 10) {
            minutes = `0${minutes}:`;
        } else {
            minutes = `${minutes}:`;
        }
        if (hour === 0) {
            hour = '';
        } else {
            hour = `${hour}:`;
        }
        return hour + minutes + seconds;
    } else {
        return '';
    }
}

export function convertTimeToHMS(time, noSec) {
    let date = new Date(time);
    if (time && time > 0) {
        let sec = date.getSeconds();
        let min = date.getMinutes();
        let hour = date.getHours();
        if (sec === 0) {
            sec = ':00';
        } else if (sec < 10) {
            sec = ':0' + sec;
        }
        let minutes = min % 60;
        if (minutes === 0) {
            minutes = '00';
        } else if (minutes < 10) {
            minutes = `0${minutes}`;
        } else {
            minutes = `${minutes}`;
        }
        if (hour === 0) {
            hour = '00:';
        } else if (hour < 10) {
            hour = `0${hour}:`;
        } else {
            hour = `${hour}:`;
        }
        if (noSec) {
            return hour + minutes;
        } else {
            return hour + minutes + sec;
        }
    } else {
        return '';
    }
}

export function convertTimeToYMD(ts) {
    let now = new Date(ts);
    return now.getFullYear() + '年' + (now.getMonth() + 1) + '月' + now.getDate() + '日';
}

export function getNow() {
    let now = new Date();
    now.setTime(now.getTime() + (now.getTimezoneOffset() + 480) * 60 * 1000);
    return now;
}

export function convertTimeToSimple(time) {
    if (isNaN(Number(time))) return '--';
    let now = getNow().getTime();
    let timeSub = now - time;
    let min = timeSub / 60 / 1000;
    let hour = min / 60;
    let day = hour / 24;
    let month = day / 30;
    let year = month / 12;
    if (min < 60) {
        return `${min.toFixed(0) === 0 ? 1 : min.toFixed(0)}分钟前`;
    } else if (hour < 24) {
        return `${hour.toFixed(0)}小时前`;
    } else if (day < 30) {
        return `${day.toFixed(0)}天前`;
    } else if (month < 12) {
        return `${month.toFixed(0)}月前`;
    } else {
        return `${year.toFixed(0)}年前`;
    }
}

export function formatDateToYMD(date, split, hasTime, strict, hasYear) {
    split = split === undefined ? '/' : split;
    strict = strict !== undefined;
    let year = date.getFullYear();
    let month = date.getMonth() + 1;
    let day = date.getDate();
    if (strict) {
        month = month < 10 ? `0${month}` : month.toString();
        day = day < 10 ? `0${day}` : day.toString();
    }
    if (hasTime) {
        let hour = date.getHours();
        let min = date.getMinutes();
        if (strict) {
            hour = hour < 10 ? `0${hour}` : hour.toString();
            min = min < 10 ? `0${min}` : min.toString();
        }
        return (hasYear ? (year + split) : '') + month + split + day + ' ' + hour + ':' + min;
    } else {
        return (hasYear ? (year + split) : '') + month + split + day;
    }
}

export function formatReviewDate(date) {
    let now = offsetDate(new Date());
    let timeSub = now.getTime() - date.getTime();
    let oneMinute = 60 * 1000;
    let oneHour = 60 * oneMinute;
    let oneDay = 24 * oneHour;
    let onDayAgo = offsetDate(new Date(now.getTime() - oneDay));
    let yesterDay = offsetDate(new Date(`${onDayAgo.getFullYear()}/${onDayAgo.getMonth() + 1}/${onDayAgo.getDate()} 00:00:00`));
    if (timeSub < oneMinute) {
        return '刚刚';
    } else if (timeSub < oneHour) {
        return `${Math.round(timeSub / oneMinute)}分钟前`;
    } else if (timeSub < oneDay) {
        return `${Math.round(timeSub / oneHour)}小时前`;
    } else if (date.getTime() > yesterDay.getTime()) {
        return `昨天`;
    } else {
        return formatDateToYMD(date, '-', false, true, now.getFullYear() !== date.getFullYear());
    }
}

// 数字转换为时间格式
export function formatDuration(n) {
    if (String(n).indexOf(':') !== -1) {
        return n;
    }
    let hour = 0;
    let min = 0;
    let sec = 0;
    if ((n / 60) < 1) {
        sec = n;
    } else if ((n / 3600) < 1) {
        min = Math.floor(n / 60);
        sec = n - 60 * min;
    } else {
        hour = Math.floor(n / 3600);
        min = Math.floor((n - hour * 3600) / 60);
        sec = n - hour * 3600 - min * 60;
    }
    if (hour === 0) {
        hour = '';
    } else {
        hour = `${hour}:`;
    }
    if (min < 10) {
        min = '0' + min;
    }
    if (sec < 10) {
        sec = '0' + sec;
    }
    return `${hour}${min}:${sec}`;
}